import { CloudAccountType } from '@repo/api-gw-sdk';

export const URLS: Record<CloudAccountType, string> = {
  [CloudAccountType.Source]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/source-account.yml',
  [CloudAccountType.Vault]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/eon-vault-verification-role.yml',
  [CloudAccountType.Restore]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/restore-account.yml',
  [CloudAccountType.Scanning]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/scanning-account.yml',
  [CloudAccountType.AccountTypeUnspecified]: '',
};
